import React from "react";
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useParams,
} from "react-router-dom";
import { v4 as uuidv4 } from "uuid";

import { routes } from "@src/Routes";

const normalizeView = (producedView) => {
  const uuid = producedView?.uuid || uuidv4();

  return {
    uuid,
    view: () => (
      <div key={uuid} style={{ height: "100%" }}>
        {producedView?.view ? producedView.view() : producedView}
      </div>
    ),
  };
};

const BrowserRoute = ({ gui, route }) => {
  const params = useParams();
  const location = useLocation();

  React.useEffect(() => {
    if (!gui || !route?.view) return;

    const producedView = route.view(gui, params);
    gui.canISwitchTo(normalizeView(producedView));
  }, [gui, route, location.pathname]);

  return null;
};

const RouteNotFound = () => {
  const location = useLocation();

  const missedPath = `${location.pathname}${location.search}${location.hash}`;

  React.useEffect(() => {
    console.error("[Routes] No route matched:", missedPath);
    console.error(
      "[Routes] Known routes:",
      routes.map((route) => route.path)
    );
  }, [missedPath]);

  return <Navigate to="/" replace />;
};

export default function AppRoutes({ gui }) {
  return (
    <Routes>
      {routes.map((route) => (
        <Route
          key={route.path}
          path={route.path}
          element={<BrowserRoute gui={gui} route={route} />}
        />
      ))}

      <Route path="*" element={<RouteNotFound />} />
    </Routes>
  );
}